import { render, staticRenderFns } from "./TranscriptionSidebar.vue?vue&type=template&id=1b57f3ac&"
import script from "./TranscriptionSidebar.vue?vue&type=script&lang=ts&"
export * from "./TranscriptionSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./TranscriptionSidebar.vue?vue&type=style&index=0&id=1b57f3ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports